const ToolboxInfo = {
  maxInstances: { character_motion_move: 5, character_motion_turn_left: 1 },
  json: {
    kind: "categoryToolbox",
    contents: [
      {
        kind: "category",
        toolboxitemid: "category",
        contents: [
          {
            kind: "block",
            type: "character_motion_move",
          },
          {
            kind: "block",
            type: "character_motion_turn_left",
          },
        ],
      },
    ],
  },
};

export default ToolboxInfo;
